const cities = [
  { name: "Coral Springs", zips: "33065, 33067, 33071, 33073, 33076" },
  { name: "Parkland", zips: "33067, 33076" },
  { name: "Margate", zips: "33063, 33068" },
  { name: "Coconut Creek", zips: "33066, 33073" },
  { name: "Tamarac", zips: "33309, 33319, 33321" },
  { name: "North Lauderdale", zips: "33068" },
  { name: "Pompano Beach", zips: "33060, 33062, 33064, 33069, 33071, 33073" },
  { name: "Lauderhill", zips: "33311, 33313, 33319, 33351" },
];

export const landmarks = [
  { name: "Fort Lauderdale-Hollywood Intl (FLL)", distance: "~20 miles", icon: "ri-flight-takeoff-line", desc: "Closest airport — southeast via Sawgrass Expressway and I-595", url: "https://www.broward.org/airport/", schemaType: "Airport" },
  { name: "Palm Beach International Airport (PBI)", distance: "~35 miles", icon: "ri-flight-takeoff-line", desc: "Alternative airport north via Florida's Turnpike or I-95", url: "https://www.pbia.org/", schemaType: "Airport" },
  { name: "Sawgrass Expressway", distance: "~5 miles", icon: "ri-road-map-line", desc: "Primary connector to I-95, I-75, and Florida's Turnpike", url: "https://en.wikipedia.org/wiki/Florida_State_Road_869", schemaType: "CivicStructure" },
  { name: "Coral Square Mall", distance: "Downtown", icon: "ri-store-2-line", desc: "Major shopping destination with department stores, dining, and entertainment", url: "https://www.simon.com/mall/coral-square", schemaType: "TouristAttraction" },
  { name: "Sawgrass Mills", distance: "~10 miles", icon: "ri-store-2-line", desc: "Largest outlet mall in the U.S. — 350+ stores, international tourist destination", url: "https://www.simon.com/mall/sawgrass-mills", schemaType: "TouristAttraction" },
  { name: "Butterfly World", distance: "~8 miles", icon: "ri-landscape-line", desc: "Largest free-flight butterfly aviary in the U.S. at Tradewinds Park", url: "https://www.butterflyworld.com/", schemaType: "TouristAttraction" },
  { name: "Coral Springs Sportsplex", distance: "~3 miles", icon: "ri-trophy-line", desc: "Olympic-caliber aquatics facility hosting national swimming competitions", url: "https://www.coralsprings.gov/", schemaType: "TouristAttraction" },
  { name: "Port Everglades", distance: "~25 miles", icon: "ri-ship-line", desc: "World's 3rd-busiest cruise port — Royal Caribbean, Carnival, Celebrity, and more", url: "https://www.porteverglades.net/", schemaType: "TouristAttraction" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function CoralSpringsLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Coral Springs &amp; Northwest Broward County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Coral Springs, Parkland, Margate, Coconut Creek, or anywhere in northwest Broward County, Fast Passport Center makes expedited passport processing simple — as a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Coral Springs is a master-planned suburban community in northwestern Broward County — and one of the most meticulously designed cities in South Florida. Founded in 1963 by Coral Ridge Properties, the city was envisioned as a planned community with strict architectural guidelines, abundant green space, and a distinctive Mediterranean aesthetic that sets it apart from the rest of the county. Those signature red-tiled roofs on municipal buildings, the winding tree-lined streets, and the sheer density of parks (more than 50 municipal parks covering 675 acres) earned Coral Springs its official nickname: "The City in the Park."
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            With a population of roughly 135,000, Coral Springs is one of the largest cities in Broward County — yet it retains a distinctly suburban character that attracts families, professionals, and retirees seeking space, safety, and top-rated schools. Marjory Stoneman Douglas High School (shared with neighboring Parkland), Coral Springs High School, JP Taravella High, and Coral Glades High serve a diverse student body that includes families from across the economic spectrum. The Coral Springs Sportsplex — an Olympic-caliber aquatics facility — has hosted national swimming competitions and Olympic team training sessions. Butterfly World, located just outside city limits at Tradewinds Park, is the largest free-flight butterfly aviary in the United States and draws visitors from across South Florida.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Coral Springs' travel DNA is shaped by its demographics: middle to upper-middle-class families who take annual cruises from nearby Port Everglades, professionals who commute to Fort Lauderdale and Miami for work and business travel, and a significant Jewish community (many of whom also call neighboring Parkland home) that travels to Israel for bar and bat mitzvahs, family visits, and cultural events. The Sawgrass Nature Center and Wildlife Hospital at nearby Tradewinds Park, Coral Square Mall, The Walk at Coral Springs, and the Center for the Arts give the city a cultural infrastructure that supports residents who value education, nature, and the arts — and who travel to experience more of all three abroad.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Coral Springs sits at a unique geographic crossroads for travel. Fort Lauderdale-Hollywood International Airport (FLL) is just 20–25 minutes south via the Sawgrass Expressway and I-595 — making it the primary airport for most residents. Miami International (MIA) is roughly 45 minutes south via the Sawgrass and Florida's Turnpike, offering more international route options. Palm Beach International (PBI) is about 45 minutes north via I-95. And Port Everglades — the world's third-busiest cruise port — is just 25–30 minutes south, making Coral Springs one of the most cruise-accessible communities in South Florida. Royal Caribbean, Celebrity, Carnival, Norwegian, Princess, Holland America, MSC, and Disney all operate year-round Caribbean itineraries that Coral Springs families book regularly.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What unites Coral Springs travelers is a practical, family-oriented approach to international travel. Residents here are not booking spontaneous weekend getaways to Paris (though some do). They are planning spring break cruises, summer trips to Israel, Disney World followed by a connecting international flight, and business trips to Latin America. These trips require passports that are current, undamaged, and compliant with destination requirements — and they are planned far enough in advance that most families assume they have time. The problem is that "time" shrinks fast when a child's five-year passport expires unnoticed, or a water-damaged passport is discovered two weeks before a cruise departure.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Coral Springs travelers across every scenario: families at the Sportsplex whose summer swim camp in the Bahamas requires valid passports, professionals at the Sawgrass Corporate Park flying FLL to Bogota for client meetings, and grandparents in the Ramblewood South neighborhood hosting Israeli relatives who need emergency passport renewals before a group tour. Our courier-based expedited service means you start online from your Coral Springs home, ship overnight from the FedEx at Coral Square Mall or the UPS Store on West Atlantic Boulevard, and your passport arrives within days — not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Coral Springs — approximately 25–30 miles northeast via Sawgrass/Turnpike/I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Broward County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=401+W+Atlantic+Ave+%23351,+Delray+Beach,+FL+33444&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Delray Beach Office Location"
                      aria-label="Google Map showing Fast Passport Center Delray Beach office at 401 W Atlantic Ave Suite 351"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    401 W Atlantic Ave #351, Delray Beach, FL 33444
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in northwest Broward County — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Parkland", href: "/parkland" },
                  { name: "Plantation", href: "/plantation" },
                  { name: "Weston", href: "/weston" },
                  { name: "Wellington", href: "/wellington" },
                  { name: "Boca Raton", href: "/boca-raton" },
                  { name: "Fort Lauderdale", href: "/fort-lauderdale" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Nearby Landmarks & Airports */}
            <div className="mt-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                  <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
                </div>
                <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {landmarks.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                    title={item.desc}
                  >
                    <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                    <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                    <span className="text-[#F6C344] font-semibold text-[10px]">{item.distance}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}